
/* React */
import { useEffect } from 'react'

/* Material */
import Alert from '@mui/material/Alert'
import Pagination from './Pagination'
import Typo from '@mui/material/Typography'
import useStyles from './Products.styles'

/* Types */
import { tProductPreview } from 'src/shared/frontendTypes/product'

/* Components */
import Product from 'src/components/ProductPreview/Product'

/* Functions */
import setCardTitleHeights from './functions/setCardTitleHeights'
import config from 'src/config'

/* Redux */
import { useSelector } from 'src/redux/hooks'

interface Props {
  products: tProductPreview[]
  page: number
  size: number
  count: number
  requireStock?: boolean
  catalogLayout?: boolean
}

const Products: React.FC<Props> = ({ products, page, size, count, catalogLayout }) => {
  const classes = useStyles()
  const suche = useSelector(store => store.Filter.suche)
  const mobileEditorial = config.productPreview?.mobileStyle === 'editorial'

  useEffect(() => setCardTitleHeights(), [products])

  return (
    <>
      {(count === 0 || products.length === 0) && (
        <Alert severity='info' className={classes.emptyState}>
          <Typo component='div' variant='body1'>
            Keine passenden Treffer gefunden{suche ? ` für "${suche}"` : ''}.
          </Typo>
          <Typo component='div' variant='body2'>
            Versuchen Sie es mit weniger Begriffen, einer Marke, einer Farbe, einer Artikelnummer oder einer EAN.
          </Typo>
        </Alert>
      )}

      <div className={[
        'products-filter-grid',
        classes.cardGrid,
        catalogLayout ? classes.catalogCardGrid : '',
        mobileEditorial ? classes.mobileEditorialGrid : '',
      ].join(' ')}>
        {products?.map(product => (
          <Product key={product.key} product={product} />
        ))}
      </div>

      {products?.length > 0 && (
        <>
          <hr />
          <Pagination {...{ page, size, count }} />
        </>
      )}
    </>
  )
}

export default Products
